export enum ETransactionTabs {
  ActivityStatements = 'activitystatements',
  Transactions = 'transactions',
  BonusBets = 'bonusbets',
}
